import React from 'react';
import {
    AD_ACTIVE,
    AD_ACTIVE_BUT_HIDDEN,
    AD_CREATED,
    AD_READY,
    AD_EXPIRED,
    AD_INACTIVE,
} from 'common/lib/helpers/constants';
import PropTypes from 'prop-types';

const ribbonText = (status, isSold) => {
    if (isSold) {
        return 'Solgt';
    }
    switch (status) {
        case AD_ACTIVE:
            return 'Aktiv';
        case AD_ACTIVE_BUT_HIDDEN:
            return 'Skjult';
        case AD_CREATED:
        case AD_READY:
            return 'Påbegynt';
        case AD_INACTIVE:
        case AD_EXPIRED:
            return 'Utløpt';
        default:
            return '';
    }
};

const ribbonColor = (status, isSold) => {
    if (isSold) {
        return 'border-yellow-100 bg-yellow-100';
    }

    switch (status) {
        case AD_ACTIVE:
            return 'border-green-100 bg-green-100';
        case AD_CREATED:
        case AD_READY:
            return 'border-yellow-100 bg-yellow-100';
        case AD_ACTIVE_BUT_HIDDEN:
        case AD_INACTIVE:
        case AD_EXPIRED:
            return 'border-bluegray-300 bg-bluegray-300';
        default:
            return '';
    }
};
// Basing the classnames on https://github.com/fabric-ds/css/blob/main/src/utils/component-classes/index.js
// since Fabric does not have a specific component for Status Ribbon anymore

const AdStatusRibbon = ({ adStatus, isSold }) => {
    return (
        <div
            className={`mb-16 py-4 px-8 border rounded-4 inline-flex last-child:mb-0 ${ribbonColor(adStatus, isSold)}`}
        >
            {ribbonText(adStatus, isSold)}
        </div>
    );
};

AdStatusRibbon.propTypes = {
    adStatus: PropTypes.string.isRequired,
    isSold: PropTypes.bool,
};

export default AdStatusRibbon;
